import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/main.scss';

class Home extends React.Component {
  render() {
    return (
      <div className="home-page">
        <header className="home-hero">
          <div className="hero-content">
            <h1 className="hero-title">તમારા પ્રિયજનોને સુરક્ષિત કરો</h1>
            <p className="hero-sub">વ્યાપક જીવન વીમા અને સરળ પ્રક્રિયાઓ સાથે તમારા પરિવાર માટે આર્થિક સલામતી અને માનસિક શાંતિ મેળવો.</p>

            <div className="hero-actions">
              <Link to="/register" className="btn-white">હવે જોડાઓ</Link>
              <Link to="#features" className="hero-link">વિશેષતાઓ જુઓ</Link>
            </div>
          </div>
        </header>

        <main className="main-container">
          <section id="features" className="features-grid">
            <div className="feature-card">
              <h3>વ્યાપક કવરેજ</h3>
              <p>તમારી જરૂરિયાતો માટે કસ્ટમાઇઝ કરવા લાયક વિકલ્પો અને મજબૂત લાભ.</p>
            </div>

            <div className="feature-card">
              <h3>ઝડપી મંજૂરી</h3>
              <p>સાદા પગલાં અને ઝડપી પ્રક્રિયા તેનાથી વધારે સિદ્ધિ.</p>
            </div>

            <div className="feature-card">
              <h3>ભરોસાપાત્ર સહાય</h3>
              <p>આંતરરાષ્ટ્રીય-સ્તરની નિયમનકારી અનુપાલન અને સહાયક ગ્રાહક સેવા.</p>
            </div>
          </section>

          <section className="testimonial">
            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&auto=format&fit=crop&q=60" alt="testimonial" />
            <div>
              <h4>પરિવાર દ્વારા વિશ્વસનીય</h4>
              <p>"મારા પરિવાર માટે આપેલી સુરક્ષા અને સહાયથી હું ખરેખર ખુશ છું."</p>
            </div>
          </section>

          <section className="cta-section">
            <h3>તયાર છો?</h3>
            <p>આપણી સરળ નોંધણી પ્રક્રિયા દ્વારા આજે જ કામ શરૂ કરો — તમે માત્ર એક ક્લિકથી શરૂ કરી શકો છો.</p>
            <Link to="/register" className="cta-btn">અરજી શરૂ કરો</Link>
          </section>
        </main>

        <footer className="site-footer">© 2026 LifeGuard Insurance. સર્વાધિકાર સુરક્ષિત.</footer>
      </div>
    );
  }
}

export default Home;
